module.exports = __webpack_public_path__ + "static/buildup_about-61e8fd21ae8fa859eb0ad4331dbc6f9a.png";